<!--
 * @Author: zl
 * @Date: 2022-09-01 09:23:31
 * @LastEditTime: 2022-09-01 15:54:53
 * @LastEditors: zl
 * @Description: 描述：项目投资构成
-->
<template>
	<div class="ContractStructureMaintenance-layout filter-layout">
		<div class="filter-box">
			<div class="primary-layout">
				<div class="primary-header">
					<div class="left-text">
						项目投资构成
						<!-- <el-tooltip placement="right"
									effect="light">
							<div slot="content">
								<p>项目投资构成:管理员创建合同结构后，运营人</p>
								<p class="mt10">员在前端可选择相应合同类型上传合同资科</p>
							</div>
							<svg-icon class="ml5"
									  icon-class="wenhao"></svg-icon>
						</el-tooltip> -->
					</div>
					<div class="btnGroups">
						<el-input v-model="searchName"
								  placeholder="请输入项目投资构成"
								  size="small"
								  class="w300"
								  @keyup.enter.native="doSearch">
							<template slot="append">
								<el-button type="primary"
										   size="small"
										   class="btn-blue"
										   @click="doSearch">查询</el-button>
							</template>
						</el-input>
						<el-button type="success"
								   size="small"
								   class="btn-success ml10"
								   icon="el-icon-refresh"
								   @click="refresh"></el-button>
					</div>
				</div>
			</div>
		</div>
		<div class="filter-content primary-layout">
			<div class="primary-header">
				<div></div>
				<div class="btnGroups">
					<el-button type="primary"
							   size="small"
							   v-if="roleBtns.includes('unlock')"
							   @click="isDisabled = !isDisabled">
						{{ isDisabled ? '解锁' : '锁定' }}
					</el-button>
					<el-button type="primary"
							   size="small"
							   :disabled="isDisabled"
							   v-if="roleBtns.includes('save')"
							   @click="doSave">保存</el-button>
					<!-- <el-button size="small"
							   disabled>导出Excel</el-button> -->
				</div>
			</div>
			<div class="primary-content">
				<vxe-table align="center"
						   auto-resize
						   border
						   :data="contractData"
						   resizable
						   row-id="treeId"
						   ref="xTable"
						   height="100%"
						   class="xTable"
						   highlight-current-row
						   highlight-hover-row
						   :loading="loading"
						   show-overflow="tooltip"
						   show-header-overflow="tooltip"
						   :tree-config="{ children: 'children', expandAll: true }"
						   :edit-config="{ trigger: 'click', mode: 'cell', activeMethod:activeRowMethod }"
						   @edit-closed="checkName">
					<vxe-table-column type="seq"
									  title="序号"
									  width="70"></vxe-table-column>
					<vxe-table-column field="sname"
									  title="项目投资构成"
									  tree-node
									  min-width="300"
									  header-align="center"
									  align="left">
						<template v-slot="{ row }">
							<el-input v-model.trim="row.sname"
									  v-if="!row.id"
									  size="small"
									  class="is-required"
									  :disabled="isDisabled"
									  maxlength="30"
									  show-word-limit
									  placeholder="请输入项目投资构成"
									  @blur="checkName(row)"></el-input>
							<div v-else>
								<span class="vxe-cell--label">
									<i class="el-icon-folder-opened mr5"></i>{{ row.sname }}
								</span>
							</div>
						</template>
					</vxe-table-column>
					<vxe-table-column field="status"
									  title="是否生效">
						<template v-slot="{ row }">
							<vxe-switch v-model="row.status"
										:open-label="row.pid != '0' ? '是' : '全开'"
										:open-value="1"
										:close-label="row.pid != '0' ? '否' : '全关'"
										:close-value="0"
										disabled
										:class="{ opacityHide: isDisabled }"
										@click.native.prevent="handleSwitch(row)"></vxe-switch>
						</template>
					</vxe-table-column>
					<vxe-table-column field="sort"
									  title="顺序">
						<template #default="{ row }">
							<div v-if="row.pid != '0'">
								<el-button type="primary"
										   size="mini"
										   :disabled="dealDisabled('up', row)"
										   icon="el-icon-arrow-up"
										   @click="moveSort('up', row)"></el-button>
								<el-button type="primary"
										   size="mini"
										   :disabled="dealDisabled('down', row)"
										   icon="el-icon-arrow-down"
										   @click="moveSort('down', row)"></el-button>
							</div>
							<div v-else>-</div>
						</template>
					</vxe-table-column>
					<vxe-table-column title="操作">
						<template v-slot="{ row }">
							<el-button type="text"
									   icon="el-icon-plus"
									   :disabled="isDisabled"
									   @click="addContract(row)"
									   v-if="row.level != 2"
									   title="添加"></el-button>
							<el-button type="text"
									   icon="el-icon-delete"
									   v-if="![0, 1].includes(row.level)"
									   :disabled="isDisabled"
									   @click="deleteContract(row)"
									   title="删除"></el-button>
						</template>
					</vxe-table-column>
				</vxe-table>
			</div>
		</div>
	</div>
</template>

<script>
import * as API from '@/api/modules/ContractStructureMaintenance'
import { mapState } from 'vuex'
export default {
	name: 'ContractStructureMaintenance',
	data() {
		return {
			searchName: '', //搜索
			isDisabled: true, //锁定、解锁
			contractData: [], //合同数据
			defaultData: [], //原始数据
			loading: false, //加载
		}
	},
	created() {
		this.getContractData('1')
	},
	methods: {
		// 获取合同结构数据
		getContractData(data) {
			if (data != '1') {
				this.loading = true
			}
			this.contractData = []
			this.defaultData = []
			API.selectTemplateContract({})
				.then((res) => {
					this.contractData = this.$utils.clone(res.data, true)
					this.defaultData = this.$utils.clone(res.data, true)
					setTimeout(() => {
						this.contractData[0].children.forEach((item, index) => {
							// 将树里面的最顶级的上移禁用 最下级的下移禁用
							if (index == 0) {
								item.up = 'disabled'
							}
							if (
								index ==
								this.contractData[0].children.length - 1
							) {
								item.down = 'disabled'
							}
						})
						this.loading = false
						this.$refs.xTable.setAllTreeExpand(true)
					}, 1000)
					if (this.searchName != '') {
						this.doSearch()
					}
				})
				.catch(() => {
					this.loading = false
					this.contractData = []
				})
		},

		// 搜索
		doSearch() {
			let filterName = this.searchName.trim()
			this.contractData = []
			this.loading = true
			if (filterName) {
				let options = { children: 'children' }
				let searchProps = ['sname']

				// 树形显示
				this.contractData = this.$utils.searchTree(
					this.defaultData,
					(item) =>
						searchProps.some(
							(key) => item[key].indexOf(filterName) > -1
						),
					options
				)
				this.removeDis(this.contractData)
				// 搜索之后默认展开所有子节点
				this.$nextTick(() => {
					this.loading = false
					this.$refs.xTable.setAllTreeExpand(true)
				})
			} else {
				this.contractData = this.defaultData

				// 搜索之后默认展开所有子节点
				this.$nextTick(() => {
					this.loading = false
					this.$refs.xTable.setAllTreeExpand(true)
				})
			}
		},

		// 重置
		refresh() {
			this.searchName = ''
			this.getContractData()
		},

		// 添加层级
		addContract(data) {
			let _node = {
				pid: data.treeId, //父节点id
				status: 1, //是否生效0.否 1.是
				sname: '', //合同结构名称
				sort: this.dealSort(data),
				treeId: data.treeId + (data.children.length + 1),
				children: [],
				level: data.level + 1,
			}
			data.children.push(_node)
			// 设置展开
			this.$refs.xTable.setTreeExpand(data, true)
			// 设置选中
			this.$refs.xTable.setActiveRow(_node)
		},

		// 处理sort
		dealSort(data) {
			let sort = ''
			if (data.pid == '0') {
				let obj = this.contractData[0].children
				if (obj.length > 0) {
					sort = obj[obj.length - 1].sort + 1
				} else {
					sort = 1
				}
			} else {
				if (data.children.length > 0) {
					sort = data.children[data.children.length - 1].sort + 1
				} else {
					sort = 1
				}
			}
			return sort
		},

		// 删除层级
		async deleteContract(data) {
			// 找到父节点
			let _parent = this.$utils.findTree(
				this.contractData,
				(x) => x.treeId === data.pid
			)
			if (!data.id) {
				this.deleteMethod(_parent.item, data)
				return
			}

			// 已经存在的 接口删除
			this.loading = true
			let status = await this.$deleteConfirm('是否确认删除该结构？', true)
			if (status) {
				API.deleteTemplateContract({
					id: data.id,
				})
					.then((res) => {
						this.deleteMethod(_parent.item, data, 'no')
						this.$refs.xTable.setAllTreeExpand(false)
						setTimeout(() => {
							this.doSave()
						}, 100)
					})
					.catch(() => {
						this.loading = false
					})
			} else {
				this.$message.info('操作取消')
				this.loading = false
			}
		},

		// 删除公共函数（有 id 和 没id）
		deleteMethod(_parent, row, type) {
			if (_parent) {
				// 删除节点
				_parent.children.splice(
					_parent.children.findIndex((x) => x.treeId === row.treeId),
					1
				)
				if (type != 'no') {
					this.loading = false
				}
			}
		},

		// 移动顺序
		async moveSort(type, data) {
			if (!data.id) {
				this.$message.error('新增的节点请保存后在移动顺序！')
				return
			}
			let status = await this.$deleteConfirm('是否确认要移动顺序？', true)
			if (status) {
				// 找到自己的下标
				let _index = this.$utils.findTree(
					this.contractData,
					(x) => x.treeId == data.treeId
				).index
				// 找到父节点
				let pObj = this.$utils.findTree(
					this.contractData,
					(x) => x.id == data.pid
				).item
				let moveList = []
				// 获取移动的两个元素
				moveList = this.dealIndex(type, _index, pObj)
				// 接收到的moveList 不存在就return
				if (!moveList) {
					return
				}
				// 拷贝moveList
				let copyObj = this.$utils.clone(moveList, true)
				// 将要切换顺序的节点的 sort 切换
				moveList[0].sort = copyObj[1].sort
				moveList[1].sort = copyObj[0].sort
				this.loading = true
				API.upOrDownTemplateContract({
					moveList,
				}).then((res) => {
					this.doSave()
				})
			} else {
				this.$message.info('操作取消！')
			}
		},

		// 判断节点是不是最上面或者最下面
		dealIndex(type, _index, pObj) {
			let moveList = []
			if (type == 'up') {
				// 像上移 如果已经是最上面的 则不能移动
				if (_index == 0) {
					this.$message.error(
						'该节点以位于当前父节点下所有节点的最上面！'
					)
					return
				}
				// 上移将当前下标的元素 和 前一个元素加到 movelist
				moveList = [pObj.children[_index], pObj.children[_index - 1]]
			} else {
				// 像下移 如果已经是最下面的 则不能移动
				if (!pObj.children[_index + 1]) {
					this.$message.error(
						'该节点以位于当前父节点下所有节点的最下面！'
					)
					return
				}
				// 下移将当前下标的元素 和 后一个元素加到 movelist
				moveList = [pObj.children[_index], pObj.children[_index + 1]]
			}
			return moveList
		},

		// 保存
		doSave() {
			this.loading = true
			// 克隆从接口获取的参数
			let params = this.$utils.clone(this.contractData[0], true)
			// 判断目录名称是否填写
			let requireSname = this.$utils.filterTree(
				this.contractData,
				(x) => x.sname === ''
			)
			if (requireSname.length > 0) {
				this.$message.warning('项目投资构成为必填项!')
				this.loading = false
				return
			}
			API.saveOrUpdateTemplateContract({
				data: params,
			})
				.then((res) => {
					this.getContractData()
				})
				.catch(() => {
					this.loading = false
				})
		},

		// 是否必传change事件
		async handleSwitch(data) {
			if (this.isDisabled) {
				return
			}
			let status = await this.$deleteConfirm(
				'此操作将改变开关状态，是否确认',
				true
			)
			if (status) {
				this.loading = true
				API.setStatus({
					id: data.id,
					status: data.status == 0 ? 1 : 0,
				}).then((res) => {
					data.status == 0 ? (data.status = 1) : (data.status = 0)
					if (data.pid == '0') {
						this.getContractData()
					} else {
						this.loading = false
					}
				})
			} else {
				this.$message.info('操作取消！')
			}
		},

		// 处理禁用
		dealDisabled(type, data) {
			// 先判断有没有解锁
			if (this.isDisabled) {
				return true
			} else {
				// 二级中的的第一个禁止上移 最后一个禁止下移
				if (type == 'up') {
					if (data.up && data.up == 'disabled') {
						return true
					}
				} else {
					if (data.down && data.down == 'disabled') {
						return true
					}
				}
			}
			return false
		},

		// 项目结构不能重名
		checkName(row) {
			let repeatSname = this.$utils.filterTree(
				this.contractData,
				(x) => x.sname === row.sname
			)
			if (repeatSname.length >= 2) {
				let obj = repeatSname.find((x) => x.sname != '')
				if (obj) {
					row.sname = ''
					this.$message.error('项目投资构成不能重复')
				}
			}
		},

		// 过滤出来的移除disabled
		removeDis(data) {
			if (data.length > 0) {
				data[0].children.forEach((item) => {
					if (item.up) {
						this.$delete(item, 'up')
					}
					if (item.down) {
						this.$delete(item, 'down')
					}
				})
			}
		},

		// 单元格是否可以编辑
		activeRowMethod({ row, column }) {
			return !this.isDisabled
		},
	},
	computed: {
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns,
		}),
	},
}
</script>

<style scoped lang="less">
.ContractStructureMaintenance-layout {
	padding: 30px 20px 30px 20px;
	.filter-box {
		padding-bottom: 15px;
	}
	.primary-header {
		height: 48px;
	}
	.vxe-switch.is--disabled {
		opacity: 1;
		/deep/ .vxe-switch--button {
			cursor: pointer !important;
		}
	}
	/deep/ .is--on {
		.vxe-switch--button {
			background-color: #409eff !important;
		}
	}
	.left-text {
		font-size: 16px;
	}
	.w300 {
		/deep/ .el-input__inner {
			width: 300px !important;
		}
		.el-button {
			height: 32px !important;
			padding: 9px 20px;
		}
	}
	.xTable {
		/deep/ .vxe-tree-cell {
			.is-required {
				display: flex;
				align-items: center;
				&:before {
					content: '*';
					color: #f56c6c;
					margin-right: 4px;
				}
			}
		}
	}
}
</style>
